
/* eslint-disable no-undef */
window.$ = window.jQuery = require('jquery')
require('bootstrap-sass')
require('sweetalert')

var moment = require('moment')
moment.locale('nb')



// WEBPACK FOOTER //
// ./src/includes.js